import { MakeCall } from './createMakeCall';
import { PayoutMethods } from './types';

const getPayoutMethods = (makeCall: MakeCall) => () =>
  makeCall<PayoutMethods>('GET', `/api/v2/user/me/payout-methods`);
export { getPayoutMethods };
